import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cartItem" }
const _hoisted_2 = { class: "cartItemImg" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "cartItemDetails" }
const _hoisted_5 = { class: "cartItemName" }
const _hoisted_6 = { class: "quantitySelector d-flex" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-minus-circle" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "quantity" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "cartItemTotalPrice" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.cartItem.imageUrl
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.cartItem.name), 1),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.edit)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "quantityIcon",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.lower && _ctx.lower(...args)))
            }, _hoisted_8))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.cartItem.quantity), 1),
        (_ctx.edit)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "quantityIcon",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.higher && _ctx.higher(...args)))
            }, _hoisted_11))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, " Totale: " + _toDisplayString(_ctx.totalPrice) + " " + _toDisplayString(_ctx.cartItem.priceEntry.simbolo), 1)
    ])
  ]))
}